var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaLibrary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "21px",
    viewBox: "0 0 19 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Media Library") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-180.000000, -31.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Draft",
    transform: "translate(180.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,0.5 L18.5,19.95762 L4.81066323,19.95762 L4.81066323,0.5 L18.5,0.5 Z M18.3126713,0.742466191 L4.99640991,0.742466191 L4.99640991,19.7151538 L18.3126713,19.7151538 L18.3126713,0.742466191 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B7844D",
    x: 0.5,
    y: 0.517445649,
    width: 1.57063393,
    height: 16.3579806
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76620409,18.8963029 L1.28531697,19.8704474 L0.804429849,18.8963029 L1.76620409,18.8963029 Z",
    id: "Path-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLibrary);
export default __webpack_public_path__ + "static/media/Media Library.7e2bde7c155ea1dcc6d02be069c145a9.svg";
export { ForwardRef as ReactComponent };